import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA capabilities
// Only register in production builds to avoid dev issues
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register({
    onSuccess: () => console.log('PWA: Service worker registered successfully'),
    onUpdate: (registration) => console.log('PWA: New content available, please refresh', registration)
  });
} else {
  // Unregister service workers in development mode
  serviceWorkerRegistration.unregister();
  console.log('🔧 Development mode: Service worker disabled');
}
